/* ==========================================================================
   NEW CATEGORY GRID — behaviour
   Touch screens don't have a real ":hover" state, so this gives a brief
   visible tap feedback (the same two-tone green highlight) before the
   link navigates — otherwise the hover effect would simply never be
   seen on mobile/tablet.
   ========================================================================== */

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.new-category__card').forEach(function (card) {
    card.addEventListener(
      'touchstart',
      function () {
        card.classList.add('is-active');
      },
      { passive: true }
    );

    card.addEventListener('touchend', function () {
      setTimeout(function () {
        card.classList.remove('is-active');
      }, 150);
    });
  });
});